import { Modal } from 'react-bootstrap'

import ActionButton from '../../../components/action_button/ActionButton'
import { USER_GEOFENCE_MODAL_COLORS } from '../../../constants/uiColors'

const UserGeofenceBlockModal = ({
  showModal,
  closeModal,
  saving,
  isActivating,
  activeDistance
}) => {
  const handleConfirm = () => {
    closeModal(true)
  }

  const handleCancel = () => {
    if (!saving) {
      closeModal(false)
    }
  }

  const title = isActivating
    ? 'Activar bloqueo por geocerca'
    : 'Desactivar bloqueo por geocerca'

  const description = isActivating
    ? `Al activar esta opción, el usuario quedará bloqueado para iniciar visitas o realizar cualquier actividad mientras esté fuera de los ${activeDistance} metros configurados.`
    : 'Al desactivar esta opción, el usuario podrá iniciar visitas y realizar actividades sin importar su ubicación.'

  const confirmText = isActivating
    ? 'SÍ, ACTIVAR Y CERRAR SESIÓN'
    : 'SÍ, DESACTIVAR Y CERRAR SESIÓN'

  return (
    <Modal
      onHide={handleCancel}
      backdrop="static"
      keyboard={false}
      show={showModal}
      centered
      dialogClassName="user-geofence-modal-dialog"
      contentClassName="user-geofence-modal-content"
    >
      <Modal.Header className="user-geofence-modal-header">
        <Modal.Title className="user-geofence-modal-title">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="user-geofence-modal-body">
        <p className="user-geofence-modal-description">{description}</p>

        <div className="user-geofence-modal-session-warning">
          <span className="material-symbols-outlined">warning</span>
          <span>Se forzará el cierre de sesión del usuario en su dispositivo ahora mismo.</span>
        </div>
      </Modal.Body>

      <Modal.Footer className="user-geofence-modal-footer">
        <ActionButton
          onClick={handleCancel}
          text="CANCELAR"
          variant="outlined"
          color={USER_GEOFENCE_MODAL_COLORS.cancelBorder}
          textColor={USER_GEOFENCE_MODAL_COLORS.cancelText}
          disabled={saving}
          sx={{
            minWidth: 100,
            height: 34,
            borderRadius: 1.25,
            fontSize: 13,
            fontWeight: 600,
            '&:hover': {
              backgroundColor: USER_GEOFENCE_MODAL_COLORS.cancelHoverBackground,
              borderColor: USER_GEOFENCE_MODAL_COLORS.cancelBorder,
              color: USER_GEOFENCE_MODAL_COLORS.cancelText
            },
            '&.Mui-disabled': {
              borderColor: USER_GEOFENCE_MODAL_COLORS.cancelDisabledBorder,
              color: USER_GEOFENCE_MODAL_COLORS.cancelDisabledText,
              backgroundColor: USER_GEOFENCE_MODAL_COLORS.cancelHoverBackground
            }
          }}
        />
        <ActionButton
          onClick={handleConfirm}
          text={confirmText}
          color={USER_GEOFENCE_MODAL_COLORS.confirm}
          disabled={saving}
          sx={{
            minWidth: 220,
            height: 34,
            borderRadius: 1.25,
            fontSize: 13,
            fontWeight: 600,
            '&.Mui-disabled': {
              borderColor: USER_GEOFENCE_MODAL_COLORS.confirmDisabledBorder,
              color: USER_GEOFENCE_MODAL_COLORS.confirmDisabledText,
              backgroundColor: USER_GEOFENCE_MODAL_COLORS.confirmDisabledBackground
            }
          }}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default UserGeofenceBlockModal
